import React from "react";
import "./footerpage.css";

const FooterPage = () => {
  return (
    <>
      <div className="page">
        <section className="contact-section">
          {/* Top columns wrapper */}
          <div className="contact-wrapper">
            {/* Follow us column */}
            <div className="column col-follow">
              <div className="column-title">Follow us on</div>
              <div className="social-icons">
                <a href="https://www.facebook.com/HomeShiksha" target="_blank" rel="noopener noreferrer">
                  <img src="./facebook.svg" alt="Facebook" />
                </a>
                <a href="https://x.com/homeshiksha" target="_blank" rel="noopener noreferrer">
                  <img src="./x_img.png" alt="X (Twitter)" />
                </a>
                <a href="https://www.linkedin.com/company/home-shiksha/" target="_blank" rel="noopener noreferrer">
                  <img src="./linkdin.svg" alt="LinkedIn" />
                </a>
                <a href="https://www.instagram.com/homeshiksha/?hl=en" target="_blank" rel="noopener noreferrer">
                  <img src="./instagram.svg" alt="Instagram" />
                </a>
              </div>
            </div>
            {/* Company column */}
            <div className="column col-company">
              <div className="column-title">Company</div>
              <div className="column-list">
                <a href="https://homeshiksha.com/blogs/" target="_blank" rel="noopener noreferrer">
                  Homeshiksha Blog
                </a>
                <a href="https://homeshiksha.com/about-us/" target="_blank" rel="noopener noreferrer">
                  About Us
                </a>
                <a href="https://homeshiksha.com/franchise/" target="_blank" rel="noopener noreferrer">
                  Own a Franchise
                </a>
              </div>
            </div>
            {/* Others column */}
            <div className="column col-others">
              <div className="column-title">Others</div>
              <div className="column-list">
                <a href="https://homeshiksha.com/personal-online-tutor-for-gmat-gre-ielts-sat-cat-entrance-exam/">
                  Online Tutor for GMAT, GRE, IELTS, SAT, CAT entrance
                </a>
                <a href="https://homeshiksha.com/need-special-educator-or-shadow-teacher/">
                  Need Special Educator or Shadow Teacher
                </a>
                <a href="https://homeshiksha.com/personal-online-tutor-for-cbse-ib-igcse-cambridge-state-syllabus/">
                  Personal Online Tutor For CBSE, IB, IGCSE, CAMBRIDGE, STATE Syllabus
                </a>
                <a href="https://homeshiksha.com/online-tutor-for-foreign-language/">
                  Online Tutor for Foreign language
                </a>
              </div>
            </div>
          </div>
          {/* Contact details + footer text */}
          <div className="contact-footer">
            <div className="contact-footer-top">
              <div className="contact-footer-title">Get In Touch</div>
              <div className="contact-footer-row">
                <div className="phone-row">
                  <a href="tel:+919642222147">+91-9642222147</a>
                  <a href="tel:+919133416664">+91-9133416664</a>
                </div>
                <a href="mailto:contact@homeshiksha.com">contact@homeshiksha.com</a>
              </div>
            </div>
            <div className="contact-footer-divider" />
            <div className="contact-footer-bottom">
              <a href="https://homeshiksha.com/parents-terms-and-conditions/" target="_blank" rel="noopener noreferrer">Parents Terms and conditions</a>
              {" | "}
              <a href="https://homeshiksha.com/tutors-terms-and-conditions/" target="_blank" rel="noopener noreferrer">Tutors Terms and conditions</a>
              <br />
              This website is owned by Stelliam Services Private Limited | Copyright © 2026 HomeShiksha
              <br />
              All Rights Reserved.
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FooterPage;
